module.exports = "<p>\n  news-feed works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/news-feed/news-feed.component.html
// module id = 471
// module chunks = 0